<template>
  <div class="app-container">
    <h1>{{ $tc('message.home.menu.tasas.titulo', 2) }}</h1>
    <div><CardList :cards="opciones"></CardList></div>
  </div>
</template>

<script>
import { CardList } from '@/components';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'tasasIndex',
  data() {
    return {
      cardList: [
        {
          name: this.$t('message.tasas.menu.presentar.titulo'),
          detail: this.$t('message.tasas.menu.presentar.detalle'),
          icon: 'description',
          path: '/tasas/presentacion'
        },
        {
          name: this.$t('message.tasas.menu.consultarDeclaraciones.titulo'),
          detail: this.$t('message.tasas.menu.consultarDeclaraciones.detalle', {
            tipo: this.$options.filters.tipoEmpresaName(
              this.$store.getters.empresaSelected.cdtipemp
            )
          }),
          icon: 'format_list_bulleted',
          path: '/tasas/consulta'
        },
        {
          name: this.$t('message.tasas.menu.pagar.titulo'),
          detail: this.$t('message.tasas.menu.pagar.detalle'),
          icon: 'euro_symbol',
          path: '/tasas/pago'
        }
        /*,
        {
          name: this.$t('message.tasas.menu.consultarPagos.titulo'),
          detail: this.$t('message.tasas.menu.consultarPagos.detalle'),
          icon: 'format_list_bulleted',
          path: '/tasas/consulta-pagos'
        }*/
      ]
    };
  },
  components: {
    CardList
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [{ text: 'Inicio', to: '/' }, { text: 'Tasas', to: '/tasas' }],
      menuSelected: '/tasas'
    });
  },
  methods: {
    ...mapActions(['setBreadcrumb'])
  },
  computed: {
    ...mapGetters(['isGasElectricidad']),
    opciones() {
      if (!this.isGasElectricidad) {
        return this.cardList.filter(
          item => item.path === '/tasas/consulta-pagos' || item.path === '/tasas/pago'
        );
      }
      // gas y electricidad
      return this.cardList.filter(
        item => item.path !== '/tasas/presentacion' || !this.$store.getters.empresaSelected.febaja
      );
    }
  }
};
</script>
